<section class="cta-banner" aria-labelledby="cta-banner-title">
  <div class="cta-banner__panel">
    <div class="cta-banner__content">
      <p class="cta-banner__eyebrow">Begin your evaluation</p>

      <h2 id="cta-banner-title" class="cta-banner__title">
        Ready to benchmark your AI model?
      </h2>

      <p class="cta-banner__text">
        Explore available benchmarking datasets and securely evaluate your AI model.
      </p>

      <a class="cta-banner__btn" routerLink="/reference">
        Explore datasets
        <svg viewBox="0 0 16 16" aria-hidden="true">
          <path
            d="M8.79 2.29a1 1 0 0 1 1.42 0l4.5 4.5a1 1 0 0 1 0 1.42l-4.5 4.5a1 1 0 0 1-1.42-1.42L11.09 9H2a1 1 0 0 1 0-2h9.09L8.79 3.71a1 1 0 0 1 0-1.42Z"
            fill="currentColor"
          />
        </svg>
      </a>
    </div>
  </div>
</section>
